// import { initializeApp } from "firebase/app";
export const EXECUTIVE = "EXECUTIVE";
export const EXECUTIVE_ID = "EXECUTIVE_ID"
export const WHATSAPPSMS_ID = "WHATSAPPSMS_ID"
export const WHATSAPPSMS = "WHATSAPPSMS"
export const MESSAGETEMPLETE = "MESSAGETEMPLETE"